import Moment from "moment";
// MDB Shims Imports
import Button from "../../Component/MDBShim/Button";
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import Col from "../../Component/MDBShim/Col";
import Container from "../../Component/MDBShim/Container";
import Spinner from "../../Component/MDBShim/Spinner";
import Row from "../../Component/MDBShim/Row";
import MDBIcon from "../../Component/MDBShim/MDBIcon";
import MDBDatePicker from "../../Component/MDBShim/MDBDatePicker";
import DataTable from "../../Component/MDBShim/DataTable";

import Select from "react-select";
import ReactTooltip from "react-tooltip";
import reportsService from "../Security/ReportsService/reportsService";
import GlobalFunctions from "../Filters/GlobalFunctions";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";
import { flushSync } from "react-dom";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

const fixedLightMaterialUITheme = createTheme({
  palette: { mode: "light" },
});
const todayDate = Moment().format("YYYY-MM-DD");

export default class inventoryTracking extends LayerLegacy {
  constructor(props) {
    super(props);

    const data = {
      columns: [
        {
          label: "id",
          field: "id",
          sort: "asc",
          width: 100,
        },
        {
          label: "Service Location",
          field: "serviceLocation",
          sort: "asc",
          width: 200,
        },
        {
          label: "Order Id",
          field: "orderId",
          sort: "asc",
          width: 100,
        },
        {
          label: "Setup Date",
          field: "setupDate",
          sort: "asc",
          width: 100,
        },
        {
          label: "Patient Name",
          field: "patientName",
          sort: "asc",
          width: 50,
        },
        {
          label: "Equipment",
          field: "equipment",
          sort: "asc",
          width: 100,
        },
        {
          label: "Serial",
          field: "serial",
          sort: "asc",
          width: 100,
        },
        {
          label: "Quantity",
          field: "qty",
          sort: "asc",
          width: 100,
        },
      ],
      rows: [],
    };

    this.state = {
      data: data,
      isLoaded: false,
      startDate: todayDate,
      endDate: todayDate,
      allLocs: [],
      locationsSelect: [
        {
          label: "Loading...",
          value: "loading",
        },
      ],
      locationSelected: [],
      showDatePicker: true,
      quickFilter: [],
    };
  }

  static contextType = MainContext; // For legacy class components

  componentDidMount() {
    this.getLocationsOptions();
    this.getLocalStorage();
  }

  updateLocalStorage() {
    let filters = {},
      st = this.state;

    filters.startDate = st.startDate;
    filters.endDate = st.endDate;
    filters.location = st.locationSelected;

    window.localStorage.setItem(
      "inventoryReportFilters",
      JSON.stringify(filters),
    );
  }

  getLocalStorage() {
    let f = window.localStorage.getItem("inventoryReportFilters");

    if (f != null) {
      f = JSON.parse(f);

      this.setState({
        startDate: f.startDate
          ? Moment(f.startDate).format("YYYY-MM-DD")
          : todayDate,
        endDate: f.endDate ? Moment(f.endDate).format("YYYY-MM-DD") : todayDate,
        locationSelected: f.location,
        isLoaded: false,
      });
    }

    setTimeout(() => {
      if (!this.state.locationSelected || !this.state.locationSelected.value) {
        this.setState({
          isLoaded: true,
        });
      } else {
        this.getInventory();
      }
    }, 500);
  }

  getLocationsOptions() {
    const { currentUser, allLocations, userprofileLocationsIndexed } =
      this.context;

    let cu = currentUser;
    let select = [];

    if (cu.role === "SALES") {
      const userLocationIds = Object.values(userprofileLocationsIndexed)
        .filter((userprofileLocation) => {
          return userprofileLocation.userprofileId === cu.id;
        })
        .map((userprofileLocation) => {
          return userprofileLocation.locationsId;
        });

      const userLocations = allLocations.filter((location) => {
        return userLocationIds.includes(location.id);
      });

      userLocations.forEach((location) => {
        if (location.type === 0) {
          select.push({
            label: location.name,
            value: location.id,
          });
        }
      });

      this.setState({
        locationsSelect: select,
        allLocs: userLocations,
      });
    } else {
      allLocations.forEach((obj) => {
        select.push({
          label: obj.name,
          value: obj.id.toString(),
        });
      });

      this.setState({
        locationsSelect: select,
        allLocs: allLocations,
      });
    }
  }

  handleLocationChange = (e) => {
    this.setState({
      locationSelected: e,
    });
  };

  handleDatePickerChange = (property, value) => {
    this.setState({
      [property]: value,
    });
  };

  renderFilter() {
    let st = this.state;
    return (
      <Card style={{ marginBottom: "1%", backgroundColor: "#5881C1" }}>
        <CardBody>
          <Row gap={4} style={{ justifyContent: "center" }}>
            <Col md={"3"} className={"filterSearchBoxCol"}>
              <Select
                placeholder="Select Location"
                closeMenuOnSelect={true}
                isClearable
                options={st.locationsSelect}
                onChange={this.handleLocationChange.bind(this)}
                value={st.locationSelected}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </Col>

            <Col md={"2"} className={"filterSearchBoxCol"}>
              <div className={"expenseDateOptions"}>
                <MDBDatePicker
                  fullWidth
                  className={"openDatePicker"}
                  label={"Start Date"}
                  showTodayButton
                  autoOk
                  allowKeyboardControl
                  keyboard={true}
                  okLabel={false}
                  value={this.state.startDate}
                  getValue={this.handleDatePickerChange.bind(this, "startDate")}
                />
              </div>
            </Col>
            <Col md={"2"} className={"filterSearchBoxCol"}>
              <div className={"expenseDateOptions"}>
                <MDBDatePicker
                  fullWidth
                  className={"openDatePicker"}
                  label={"End Date"}
                  showTodayButton
                  autoOk
                  allowKeyboardControl
                  keyboard={true}
                  okLabel={false}
                  value={this.state.endDate}
                  getValue={this.handleDatePickerChange.bind(this, "endDate")}
                />
              </div>
            </Col>
            <Col className={"filterSearchBoxCol"}>
              <Button
                floating
                size="sm"
                color={"indigo"}
                data-tip={"Search"}
                onClick={() => this.filterClicked()}
              >
                <MDBIcon icon="search" style={{ fontSize: "2em" }} />
              </Button>
            </Col>
            <ReactTooltip />
          </Row>
        </CardBody>
      </Card>
    );
  }

  filterClicked = () => {
    if (!this.state.locationSelected || !this.state.locationSelected.value) {
      NotistackEnqueueSnackbar("Please Choose a Location", {
        variant: "warning",
      });
      return;
    }
    this.setState({
      isLoaded: false,
    });
    this.updateLocalStorage();
    this.getInventory();
  };

  clientCSV(stateData, filename) {
    let result,
      ctr,
      keys = [],
      headers = [],
      columnDelimiter = ",",
      lineDelimiter = "\n",
      data;

    data = stateData.rows || null;
    if (data == null || !data.length) {
      return null;
    }

    stateData.columns.forEach((col) => {
      keys.push(col.field);
      headers.push(col.label);
    });

    let replace = ["description", "account", "setupDate", "equipment"],
      children = ["account"];

    result = "";
    result += headers.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;

        if (children.indexOf(key) > -1 && item[key] != null) {
          //a child in this case is the object, but we just want the text...BC
          result += item[key].props.children.replace(/,/g, " ");
        } else if (replace.indexOf(key) > -1 && item[key] != null) {
          result += item[key].replace(/,/g, " ");
        } else {
          result += item[key];
        }

        ctr++;
      });
      result += lineDelimiter;
    });

    this.downloadBlob(result, filename);
  }

  //this actually prompts the download
  downloadBlob(csvData, filename) {
    let blob = new Blob([csvData], {
      type: "application/csv;charset=utf-8;",
    });

    if (window.navigator.msSaveBlob) {
      // FOR IE BROWSER
      navigator.msSaveBlob(blob, filename);
    } else {
      // FOR OTHER BROWSERS
      let link = document.createElement("a"),
        csvUrl = URL.createObjectURL(blob);

      link.href = csvUrl;
      link.style = "visibility:hidden";
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  getInventory() {
    let st = this.state,
      filters = {},
      sd = Moment(st.startDate, "YYYY-MM-DD", true),
      ed = Moment(st.endDate, "YYYY-MM-DD", true);

    if (st.startDate) {
      //Need to apply time as 0 for the start date...BC
      filters.startDate = sd.format("YYYY/MM/DD");
      // + "T00:00:00.000Z";
    } else {
      NotistackEnqueueSnackbar("Please Choose a start date", {
        variant: "warning",
      });
      return;
    }

    if (st.locationSelected) {
      //Need to apply time as 0 for the start date...BC
      filters.location = st.locationSelected.value;
    }

    if (st.endDate) {
      //Need to apply time as 23:59 for the end date...BC
      filters.endDate = ed.format("YYYY/MM/DD");
      // + "T23:59:59.000Z";
    } else {
      NotistackEnqueueSnackbar("Please Choose an end date", {
        variant: "warning",
      });
      return;
    }

    this.setState({ isLoaded: false });

    var f = {
      start: filters.startDate || "",
      end: filters.endDate || "",
      locationId: filters.location || "",
    };

    reportsService
      .getInventoryReport(f)
      .then((res) => {
        flushSync(() => {
          // PATCH
          this.setState({ inventoryReport: res });
        });
        this.formatRows();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  formatRows() {
    let inventory = this.state.inventoryReport,
      dt = this.state.data,
      ary = [];

    inventory.forEach((activity, index) => {
      ary.push({
        id: activity.id,
        serviceLocation: activity.serviceLocation || "Unknown",
        orderId: activity.orderId || "Unknown",
        setupDate: activity.setupDate
          ? GlobalFunctions.formatDate(activity.setupDate)
          : "Unknown",
        patientName: activity.patientName || "Unknown",
        equipment: activity.equipment || "Unknown",
        serial: activity.serial || "Unknown",
        qty: activity.qty || "",
      });
    });

    dt.rows = ary;

    this.setState({
      data: dt,
      isLoaded: true,
    });
  }

  renderTable() {
    if (this.state.isLoaded === true) {
      return (
        <DataTable
          pagination
          search
          striped
          bordered
          responsive
          autoWidth={false}
          info={false}
          data={this.state.data}
        >
          {" "}
        </DataTable>
      );
    } else {
      return this.renderLoadingSpinner();
    }
  }

  renderLoadingSpinner() {
    return (
      <Container className="mt-5">
        <div style={{ textAlign: "center", verticalAlign: "center" }}>
          <Spinner multicolor />
        </div>
      </Container>
    );
  }

  renderContent() {
    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <div style={{ marginLeft: "5%", marginRight: "5%" }}>
          {this.renderFilter()}
          <Card style={{ marginBottom: ".5%" }}>
            <CardBody>{this.renderTable()}</CardBody>
          </Card>
          <div className={"fixed-bottom downloadCsvDiv"}>
            <Button
              floating
              size="sm"
              className={"downloadCsvButton"}
              color={"primary"}
              data-tip={"Download CSV"}
              onClick={this.clientCSV.bind(
                this,
                this.state.data,
                "Inventory Tracking.csv",
              )}
            >
              <MDBIcon icon="download" style={{ fontSize: "2em" }} />
            </Button>
            <ReactTooltip />
          </div>
        </div>
      </ThemeProvider>
    );
  }
}
